import { Components } from '@mui/material';

export const MuiSwitch: Components['MuiSwitch'] = {
  styleOverrides: {
    root: {
      height: 32,
      padding: 0,
      width: 52,
    },
    switchBase: {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: '#1C5BFE',
          borderColor: '#1C5BFE',
          boxShadow: '#1C5BFE 0px 0px 0px 16px inset',
          opacity: 1,
        },
        '& .MuiSwitch-thumb': {
          boxShadow: 'none',
        },
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.4,
      },
      left: '1px',
      padding: 0,
      top: '1px',
    },
    thumb: {
      backgroundColor: '#fff',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.4)',
      height: 30,
      width: 30,
    },
    track: {
      backgroundColor: '#fff',
      border: '1px solid #dfdfdf',
      borderRadius: 16,
      boxShadow: '#dfdfdf 0px 0px 0px 0px inset',
      boxSizing: 'border-box',
      height: '100%',
      left: 0,
      margin: 0,
      opacity: 1,
      position: 'absolute',
      top: 0,
      transition: 'border 0.4s, box-shadow 0.4s, background-color 0.8s',
      width: '100%',
    },
  },
};
